import { createStore } from "vuex";
import {
  getToken,
  setToken,
  removeToken,
  setTenantNumber,
  getStoredRefreshToken,
  getStoredTenantNumber
} from '@/utils/auth'
import { login, logout, getInfo } from '@/api/login'
import { messageList, unreadCount } from "@/api/message";
import axios from "axios";

export default createStore({
  state: {
    currentLanguage: process.env.VUE_APP_DEFAULT_LOCALE || 'zh-cn',
    avatar: '',
    nickName: '',
    token: getToken(),
    messageList: [],
    unreadCount: 0,
    hideConfigButton: false,
    isPinned: false,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    sidebarMinimize(state) {
      let sidenav_show = document.querySelector("#app");
      if (state.isPinned) {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        sidenav_show.classList.remove("g-sidenav-hidden");
        state.isPinned = true;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      state.isNavFixed = !state.isNavFixed;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, nickName) => {
      state.nickName = nickName;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_LANGUAGE: (state, currentLanguage) => {
      state.currentLanguage = currentLanguage;
    },
    SET_MESSAGES: (state, messages) => {
      state.messageList = messages;
    },
    SET_UNREAD_COUNT: (state, count) => {
      state.unreadCount = count;
    }
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    // 退出系统
    logOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '');
          commit('SET_NAME', '');
          removeToken();
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 自动获取用户信息
    setUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(res => {
            if (res && res.data) {
              const { nickname, avatar, id } = res.data;
              commit('SET_NAME', nickname);
              commit('SET_AVATAR', avatar);

              // 将 userId 传递到 index.html
              if (id) {
                window.dataLayer = window.dataLayer || [];
                function gtag(){ dataLayer.push(arguments); }
                gtag('config', 'G-S16NX733BN', { 'user_id': id });
              }
            }
            return Promise.all([messageList(), unreadCount()]);
          })
          .then(([messageRes, unreadRes]) => {
            if (messageRes && messageRes.data?.list && unreadRes && unreadRes.data) {
              commit('SET_MESSAGES', messageRes.data.list);
              commit('SET_UNREAD_COUNT', unreadRes.data);
            }
            resolve();
          })
          .catch(err => {
            console.log('err', err);
            reject(err);
          });
      });
    },
    // 初始化时获取用户信息
    initializeUserInfo({ dispatch, state }) {
      if (state.token) {
        dispatch('setUserInfo');
      }
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language);
    }
  },
  getters: {
    getName: (state) => state.nickName,
    getAvatar: (state) => state.avatar,
    getLanguage: (state) => state.currentLanguage,
    getMessageList: (state) => state.messageList,
    getUnreadCount: (state) => state.unreadCount,
  },
});
